import styled from "styled-components";
import {
  Flex,
  Button,
  DialogTitle,
  List,
} from "@ebscois/react-component-library";

export const StyledWrapper = styled(Flex)`
  margin-left: auto;

  @media print {
    display: none;
  }
`;

export const StyledButton = styled(Button)`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const StyledDialogTitle = styled(DialogTitle)`
  padding: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.xl}
    ${({ theme }) => theme.space.md};
`;

export const StyledDialogContent = styled.div`
  padding: 0 ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.xl};
`;

export const StyledList = styled(List)`
  margin-bottom: ${({ theme }) => theme.space.md};
`;
